export default {
    beforeMount() {
        this.read_only = (this.$route.query.read_only==="true");
        if(this.$route.query.companyId) {
            this.companyId = parseInt(this.$route.query.companyId);
        }
        if(this.$route.query.projectId) {
            this.projectId = parseInt(this.$route.query.projectId);
        }
        if(this.$route.query.productId)
            this.productId = parseInt(this.$route.query.productId);
        if(this.$route.query.preProductId)
            this.preProductId = parseInt(this.$route.query.preProductId);
    },
    methods: {

    }
}
